import { temporarilyNotSupport } from '../../utils'

// AliPay
export const getOpenUserInfo = /* @__PURE__ */ temporarilyNotSupport('getOpenUserInfo')
export const tradePay = /* @__PURE__ */ temporarilyNotSupport('tradePay')
